<div class="no-data-block">
  <div class="no-data">   
    @if (!isDefault) {
      <img [src]="'assets/images/noSearchDataNew.svg'" alt="No Data" />
    }
    @if (!isDefault) {
      <div>
        <div><span class="msg">{{constants.NO_DATA_FOUND_1}}</span></div>
        @if (!message) {
          <div><span>{{constants.NO_DATA_FOUND_2}}</span></div>
        }
        @if (message) {
          <div><span>{{message}}</span></div>
        }
      </div>
    }
  </div>
</div>
